import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import client from '@/ports/api-client'
import { PadInfo } from '@/features/Pad'

type Error = {
  message: string
}

const getData = async (): Promise<PadInfo> => {
  try {
    const data = await client.get('/settlements/pad')
    return data
  } catch (err) {
    throw err
  }
}

const useGetPadInfo = (config?: Omit<UseQueryOptions<PadInfo, Error>, 'queryKey' | 'queryFn'>) => {
  const values = useQuery<PadInfo, Error>({
    queryKey: ['settlements', 'pad'],
    queryFn: getData,
    staleTime: 5 * 60000,
    placeholderData: {} as PadInfo,
    ...config
  })
  const isLoading = values.isLoading || values.isFetching
  return { ...values, isLoading }
}

export default useGetPadInfo
